import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { IndividualStartRenewalComponent } from './individual-start-renewal/individual-start-renewal.component';
import { AuthGuard } from '../../shared/security/auth.guard';
import { IndividualQuestionnaireComponent } from './individual-questionnaire/individual-questionnaire.component';
import { FormsModule } from '@angular/forms';
import { PipeModule } from '../../shared/pipes/pipe.module';
import { PTLSharedModule } from '../../shared/shared.module';
import { IndividualRenewalService } from './individual-renewal.service';
import { IndividualCorporationStatusComponent } from './individual-corporation-status/individual-corporation-status.component';
import { IndividualVerifyQuestionnaireComponent } from './individual-verify-questionnaire/individual-verify-questionnaire.component';
import { IndividualReviewRenewalComponent } from './individual-review-renewal/individual-review-renewal.component';
import { IndividualCompleteRenewalComponent } from './individual-complete-renewal/individual-complete-renewal.component';

const routes: Routes = [
  { path: 'startIndividualRenewal', component: IndividualStartRenewalComponent, canActivate: [AuthGuard]},
  { path: 'questionnaireIndividualRenewal', component: IndividualQuestionnaireComponent, canActivate: [AuthGuard]},
  { path: 'verifyIndividualRenewalQuestionnaire', component: IndividualVerifyQuestionnaireComponent, canActivate: [AuthGuard]},
  { path: 'individualReviewRenewal', component: IndividualReviewRenewalComponent, canActivate: [AuthGuard]},
  { path: 'individualCorporation', component: IndividualCorporationStatusComponent, canActivate: [AuthGuard]},
  ];
  @NgModule({
    imports: [CommonModule,RouterModule.forChild(routes), FormsModule, PipeModule, PTLSharedModule ],    
    declarations: [IndividualStartRenewalComponent, IndividualQuestionnaireComponent, IndividualCorporationStatusComponent, 
      IndividualVerifyQuestionnaireComponent, IndividualReviewRenewalComponent, IndividualCompleteRenewalComponent],
    providers :[IndividualRenewalService]
  })
export class IndividualRenewalModule { }



// WEBPACK FOOTER //
// ./src/app/renewal/individual-renewal/individual-renewal.module.ts